import React from "react";
import { PanelContainer } from "./PanelContainer";
import { StickyNote } from "lucide-react";
import { useContentContext } from "@/components/content-chat/ContentContext";
import { SummaryIntroScreen } from "@/components/summary/SummaryIntroScreen";

interface PanelProps {
  isMobile?: boolean;
  contentId?: string | null;
}

export const SummaryPanel: React.FC<PanelProps> = (props) => {
  const { content } = useContentContext();

  return (
    <PanelContainer
      {...props}
      title="Summary"
      description={
        <>
          Try asking Shattara AI:{" "}
          <span className="font-bold">"Summarize the key points from this content."</span>
        </>
      }
      icon={<StickyNote className="h-4 w-4 text-primary" />}
    >
      <SummaryIntroScreen contentId={content?.id ?? props.contentId ?? null} />
    </PanelContainer>
  );
};
